/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontWebNewUserModel
 */
export interface FrontWebNewUserModel {
    /**
     * username
     * @type {string}
     * @memberof FrontWebNewUserModel
     */
    username: string;
    /**
     * password
     * @type {string}
     * @memberof FrontWebNewUserModel
     */
    password: string;
}

/**
 * Check if a given object implements the FrontWebNewUserModel interface.
 */
export function instanceOfFrontWebNewUserModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function FrontWebNewUserModelFromJSON(json: any): FrontWebNewUserModel {
    return FrontWebNewUserModelFromJSONTyped(json, false);
}

export function FrontWebNewUserModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontWebNewUserModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': json['username'],
        'password': json['password'],
    };
}

export function FrontWebNewUserModelToJSON(value?: FrontWebNewUserModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'password': value.password,
    };
}

